import { httpDelete, httpGet, httpGetFile, httpPost } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Permission } from '../types/Permission';
import { SingleResult } from '../types/SingleResult';
import { Result } from '../types/Result';
import { AuthProfile } from '../types/AuthProfile';

const getPermissions = async (model: PaginatedRequest): Promise<PaginatedResult<Permission>> => await httpGet(`api/auth/permission`, model);
const getAppUserPermissions = async (appUserId): Promise<Result<Permission>> => await httpGet(`api/auth/permission/user/${appUserId}`);
const givePermissions = async (appUserId, permissionIds): Promise<SingleResult<AuthProfile>> =>
  await httpPost(`api/user/${appUserId}/permissions`, permissionIds);
const revokePermission = async (appUserId, permissionCode): Promise<SingleResult<AuthProfile>> =>
  await httpDelete(`api/user/${appUserId}/permission/${permissionCode}`);
const getPermission = async (id): Promise<SingleResult<Permission>> => await httpGet(`api/auth/permission/${id}`);

const exportPermissions = async (params): Promise<void> => await httpGetFile(`api/auth/permission/export`, params);

export { getPermission, getPermissions, getAppUserPermissions, givePermissions, revokePermission, exportPermissions };
